import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

import logo1 from "@/assets/images/dwypd_clear_logo.png";
import logo2 from "@/assets/images/german_Logo.png";
import logo3 from "@/assets/images/sci_color.png";
import logo4 from "@/assets/images/pfplogo.jpg";

// Repeat logos to make loop effect
const clientLogos = [logo1, logo2, logo3, logo4, logo1, logo2, logo3, logo4];

export default {
  name: "ClientSlider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return ({
      clientLogos,
    });
  },
};